import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';

interface LoaderProps {
  count?: number;
  className?: string;
  height?: number;
  width?: number;
  marginBottom?: number;
}

export const RectangleSkeletonLoader = ({
  count = 0,
  className,
  height,
  width,
  marginBottom,
}: LoaderProps) => {
  const numberToArray = (num: number) =>
    Array.from({ length: num }, (_, i) => i);
  const countRow = numberToArray(count);
  return (
    <>
      <Wrapper
        className={className}
        style={{
          width: width ? `${width}px` : '100%',
          height: height ? `${height}px` : '100%',
          marginBottom: marginBottom ? `${marginBottom}px` : '',
        }}
      >
        <HeaderWrapper>
          {countRow.map((_, colIndex) => (
            <Skeleton key={colIndex} height={height ?? 24} />
          ))}
        </HeaderWrapper>
      </Wrapper>
    </>
  );
};

const HeaderWrapper = styled.div`
  .react-loading-skeleton {
    --base-color: ${p => p.theme.skeletonBaseColor};
    --highlight-color: ${p => p.theme.skeletonHighlightColor};
    line-height: 0.5;
  }
  .headerTableWrapper {
    gap: 25px 15px;
    padding: 11px 25px;
  }
  & > span {
    display: flex;
    padding: 0 0 5px 0;
    line-height: 0;
  }
`;
const Wrapper = styled.div`
  padding: 0;
  &.dropdown-skeleton {
    .react-loading-skeleton {
      margin-bottom: 30px;
    }
  }

  &.form-para {
    .react-loading-skeleton {
      //Responsive
      @media (min-width: 100px) and (max-width: 319px) {
        height: 28px !important;
      }
      @media (min-width: 320px) and (max-width: 575px) {
        height: 28px !important;
      }
      @media (min-width: 576px) and (max-width: 767px) {
        height: 28px !important;
      }
      @media (min-width: 768px) and (max-width: 991px) {
        height: 28px !important;
      }
      @media (min-width: 992px) and (max-width: 1023px) {
        height: 28px !important;
      }
      @media (min-width: 1024px) and (max-width: 1279px) {
        height: 28px !important;
      }
      @media (min-width: 1280px) and (max-width: 1365px) {
        height: 32px !important;
      }
      @media (min-width: 1366px) and (max-width: 1439px) {
        height: 36px !important;
      }
      @media (min-width: 1440px) and (max-width: 1600px) {
        height: 38px !important;
      }
    }
  }
`;
